import {keyframes} from '@emotion/react';
import {FIVE_MINUTES} from '@legit.health/ui';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {Chip, Avatar, styled} from '@mui/material';
import {Link} from '@tanstack/react-router';
import {CircularLoading} from '@/shared/components/ui/Loading';
import useUserContext from '@/shared/contexts/UserContext/useUserContext';
import useNotificationsList from '@/shared/hooks/useNotificationsList';
import {NOTIFICATION_LIST} from '@/shared/routing/paths';
import {NotificationStatus} from '@/shared/views/notification/const/notifications';

const wiggle = keyframes`
  0% { transform: rotate(0deg) },
  90% { transform: rotate(0deg) },
  92% { transform: rotate(10deg) },
  94% { transform: rotate(-10deg) },
  96% { transform: rotate(10deg) },
  98% { transform: rotate(-10deg) },
  100% { transform: rotate(10deg) }
`;

const NotificationBell = styled(NotificationsIcon)({
  animation: `${wiggle} 3s infinite`
});

export default function Notifications() {
  const {user} = useUserContext();
  const {isPending, isError, data} = useNotificationsList({
    userId: user.id,
    searchParams: {page: 1, status: NotificationStatus.New},
    queryOptions: {
      refetchInterval: FIVE_MINUTES
    }
  });

  if (isPending) {
    return <CircularLoading progressSize={20} />;
  }

  if (isError) {
    return null;
  }

  const notificationsCount = data?.data?.total;

  if (notificationsCount === null || notificationsCount === undefined) {
    return null;
  }

  return (
    <Link to={NOTIFICATION_LIST}>
      <Chip
        clickable
        color={notificationsCount > 0 ? 'primary' : 'secondary'}
        label={notificationsCount > 0 ? <NotificationBell /> : <NotificationsIcon />}
        avatar={
          <Avatar
            sx={{
              fontWeight: 'bold'
            }}
          >
            {notificationsCount}
          </Avatar>
        }
      />
    </Link>
  );
}
